import React from 'react';
import { useOffline } from '../contexts/OfflineContext';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

export default function OfflineBanner() {
  const { isOnline, isSyncing, pendingOrdersCount, syncData } = useOffline();

  const handleSync = async () => {
    try {
      await syncData();
    } catch {
      toast.error('Synchronisation fehlgeschlagen');
    }
  };

  if (isOnline && pendingOrdersCount === 0) return null;

  if (isOnline && pendingOrdersCount > 0) {
    // Online but still have unsynced orders — show sync prompt
    return (
      <div className="bg-amber-500 text-white text-xs flex items-center justify-center gap-2 py-1 px-3 flex-shrink-0">
        <span>
          {pendingOrdersCount} nicht synchronisierte Bestellung{pendingOrdersCount !== 1 ? 'en' : ''}
        </span>
        <button
          onClick={handleSync}
          disabled={isSyncing}
          className="flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded px-2 py-0.5 font-semibold disabled:opacity-50 transition-colors"
        >
          <RefreshCw className={`w-3 h-3 ${isSyncing ? 'animate-spin' : ''}`} />
          Jetzt synchronisieren
        </button>
      </div>
    );
  }

  // Offline
  return (
    <div className="bg-orange-500 text-white text-xs flex items-center justify-center gap-2 py-1 px-3 flex-shrink-0">
      <span>
        Offline-Modus
        {pendingOrdersCount > 0
          ? ` — ${pendingOrdersCount} Bestellung${pendingOrdersCount !== 1 ? 'en' : ''} lokal gespeichert`
          : ' — Bestellungen werden lokal gespeichert'}
      </span>
    </div>
  );
}
